import React from 'react';

import { FormattedMessage } from 'react-intl';
import * as Yup from 'yup';
import Icon from 'app/components/Icon';
import Divider from 'app/components/Divider';
import { Col, Row } from 'react-bootstrap';
import { commonFormValidation } from 'app/modules/MyAccount/pages/Billing/utils/commonFormValidation';

export const particularFormFields = [
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.personal_data" />
      </p>
    )
  },
  {
    name: 'name',
    labelKey: 'controlpanel.form.label.name',
    disabled: true
  },
  {
    name: 'surnames',
    labelKey: 'controlpanel.form.label.lastname',
    disabled: true
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.tax_information" />
      </p>
    )
  },
  {
    name: 'country',
    labelKey: 'controlpanel.form.label.country',
    disabled: true
  },
  {
    name: 'vat',
    labelKey: 'controlpanel.form.label.nif',
    disabled: true
  },
  {
    name: 'eori',
    labelKey: 'controlpanel.form.label.eori'
  },
  {
    name: 'voec',
    labelKey: 'controlpanel.form.label.voec'
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.address" />
      </p>
    )
  },
  {
    name: 'address',
    labelKey: 'controlpanel.form.label.address',
    disabled: true
  },
  {
    name: 'city',
    labelKey: 'controlpanel.form.label.city',
    disabled: true
  },
  {
    name: 'postCode',
    labelKey: 'controlpanel.form.label.postal_code',
    disabled: true
  },
  {
    name: 'state',
    labelKey: 'controlpanel.form.label.province',
    disabled: true
  },
  {
    component: (
      <Row>
        <Col md={10} className="mg-bt-25">
          <Divider />
        </Col>
      </Row>
    )
  },
  {
    component: (
      <p className="big bold title">
        <FormattedMessage id="controlpanel.form.title.contact_information" />
      </p>
    )
  },
  {
    name: 'phonePrefix',
    labelKey: 'controlpanel.form.label.phonePrefix',
    disabled: false
  },
  {
    name: 'phone',
    labelKey: 'controlpanel.form.label.telephone',
    textPrepend: <Icon prefix="fas" icon="phone-flip" />,
    disabled: false
  }
];

export const particularFormValidation = Yup.object({ ...commonFormValidation });
